import { BaseMutations } from '@/store/base-mutations';
import { Cart } from '@/modules/cart/types';
import { SharedCartOrganization } from '@/modules/cart/shared/types';
import { Orders } from '@/modules/orders/types';
import { Dispatches, DispatchesFilters, DownloadFilters } from '../types';
import Dispatchestate from './state';

export default class DispatchMutations extends BaseMutations<Dispatchestate> {
  UPD_FILTER_KEY({ key, value }: { key: keyof DispatchesFilters | string; value: unknown }) {
    this.state.filters[key] = value;
  }

  // receiving and handling data from server

  TOGGLE_LOADING_DISPATCHES(toggle: boolean) {
    this.state.dispatches_loading = toggle;
  }

  SET_DISPATCHES(dispatches: Dispatches.Dispatch[]) {
    this.state.dispatches_list = dispatches;
  }

  SET_USER_ORGANIZATIONS(user_orgs: Orders.OrderOrganization | []) {
    this.state.user_organizations = user_orgs;
  }

  SET_EXTERNAL_ORGANIZATIONS(external_orgs: Record<'name', string>[] | []) {
    this.state.organizations_external = external_orgs;
  }

  SET_CONTRACTS(contracts: Record<'name', string>[] | []) {
    this.state.contracts = contracts;
  }

  SET_DISPATCH_DETAILS(Dispatch: Dispatches.DispatchDetailedInfo) {
    this.state.dispatch_details = Dispatch;
  }

  SET_DISPATCH_CORRECTIVE(corrective: Dispatches.DispatchСorrective) {
    this.state.dispatch_corrective = corrective;
  }

  SET_DISPATCH_RETURNS(returns: Dispatches.DispatchReturn[]) {
    this.state.dispatch_returns = returns;
  }

  SET_DOCUMENTS_DATA_DIALOG(data: Dispatches.DispatchDocument[]) {
    this.state.documents_data_dialog = data;
  }

  SET_DISPATCH_DOCUMENT_LINK(dispatch_as_document: Dispatches.ExelInfo) {
    this.state.dispatch_as_document = dispatch_as_document;
  }

  CLEAR_DISPATCH_DOCUMENT_LINK() {
    this.state.dispatch_as_document = {};
  }

  UPD_DOWNLOAD_FILTER_KEY({ key, value }: { key: keyof DownloadFilters; value: unknown }) {
    this.state.filters_download[key] = value;
  }

  SET_CATEGORIES(items: Dispatches.Categories[]) {
    this.state.categories = items;
  }

  SET_PRODUCTS(items: Dispatches.Products[]) {
    this.state.products = items;
  }

  TOGGLE_IS_DOWNLOAD(value: boolean) {
    this.state.is_download = value;
  }

  CLEAR_FILTERS_DOWNLOAD() {
    this.state.filters_download.category_ids = [];
    this.state.filters_download.product_ids = [];
    this.state.filters_download.organization_ids = [];
    this.state.filters_download.dates = [];
  }

  UPD_ALL_SELECTED_DISPATCHES(value: boolean) {
    this.state.dispatches_list = this.state.dispatches_list.map((item: Dispatches.Dispatch) => ({
      ...item,
      selected: value,
    }));
  }

  UPD_SELECTED_DISPATCHES({ item, value }: { item: Dispatches.Dispatch; value: boolean }) {
    if (!item) {
      return;
    }

    this.state.dispatches_list = this.state.dispatches_list.map((dispatch) =>
      (dispatch.id === item.id ? { ...dispatch, selected: value } : dispatch));
  }
}
